import ErrorBoundary from 'components/ErrorBoundary';
import Loader from 'components/Loader';
import Routes from 'components/Routes';
import Toast from 'components/Toast';
import GlobalContextProvider from 'context/GlobalContext/GlobalContext';
import { BrowserRouter } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <GlobalContextProvider>
          <BrowserRouter>
            <Routes />
            <Toast />
            <Loader />
          </BrowserRouter>
        </GlobalContextProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
